import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=9b00615e&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=9b00615e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b00615e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9b00615e')) {
      api.createRecord('9b00615e', component.options)
    } else {
      api.reload('9b00615e', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=9b00615e&scoped=true&", function () {
      api.rerender('9b00615e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2B7nb7XzZl3UY/JS/comp/GuestBox.vue"
export default component.exports